import React, { useState, useCallback, useEffect, useRef, Fragment } from 'react';

import { Col, Row } from 'react-bootstrap';


const business = [
    [
        {
        id: 1,
        logo: "./img/ASEGURADORAS.svg",
        name: "INSURERS",
        description: "",
        style: { top: '11%', right: '11%'}
        },
        {
        id: 2,
        logo: "./img/COMERCIO.svg",
        name: "COMMERCE",
        description: "",
        style: { bottom: '11%', right: '11%'}
        },
    ],
    [
        {
        id: 3,
        logo: "./img/ECOMMERCE.svg",
        name: "ECOMMERCE",
        description: "",
        style: { left: 0, right: 0, bottom: -15 }
        },
        {
        id: 4,
        logo: "./img/FINANCIERO.svg",
        name: "FINANCIAL",
        description: "",
        style: { top: 0, left: -15, bottom: 0 }
        },
    ],
    [
        {
        id: 5,
        logo: "./img/FINTECH.svg",
        name: "FINTECH",
        description: "",
        style: { top: -15, right: 0, left: 0}
        },
        {
        id: 6,
        logo: "./img/legal.svg",
        name: "LEGAL",
        description: "",
        style: { top: 0, right: -15, bottom: 0 }
        },
    ],
    [
        {
        id: 7,
        logo: "./img/MOVILIDAD-PAQUETERAS.svg",
        name: "MOBILITY / PACKAGES",
        description: "",
        style: { top: '11%', left: '11%'}
        },
        {
        id: 8,
        logo: "./img/MOVILIDAD.svg",
        name: "MOBILITY",
        description: "",
        style: { bottom: '11%', left: '11%', bottom: 0 }
        },
    ],
    [
        {
        id: 9,
        logo: "./img/RETAIL.svg",
        name: "RETAIL",
        description: "",
        style: { top: '9%', right: '9%'}
        }
    ]
]


    const renderInnerContainer = (item, index, setCurrentBusinessIndex, currentBusinessIndex) => {
    return (
        <Col md={10}
        className="dicio-business-container"
        style={{margin:"0 auto", padding:"34px", maxWidth:"380px"}}
        //onClick={() => setCurrentBusinessIndex(index)}
        proportional="square,static"
        >
            {
                business[index].map((businessArr, i) => {
                    return (
                        <span  
                        key={i}
                        onMouseEnter={() => setCurrentBusinessIndex(businessArr.id)}
                        onClick={() => setCurrentBusinessIndex(businessArr.id)}
                        className={`about-step-dot ${(i%2) ? '--circle' : ""} ${(currentBusinessIndex === businessArr.id) ? '--active' : ""}`}
                        style={{ ...businessArr.style, width: currentBusinessIndex === businessArr.id ? 30 : 25, height: currentBusinessIndex === businessArr.id ? 30 : 25 }}
                        >
                        </span>
                    )
                })
            }
            { business[index + 1] ? renderInnerContainer(business[index + 1], index + 1, setCurrentBusinessIndex, currentBusinessIndex) : null }
        </Col>
    )
    }

    const Business = () => {
    const [ currentBusinessIndex, setCurrentBusinessIndex ] = useState(1);
    const [ currentItem, setCurrentItem ] = useState(business[0][0])
    const infoLogo = useRef(null)
    const infoName = useRef(null)

    useEffect(() => {
        let item = {};
        business.forEach(b => {
            b.forEach(innerItem => {
                if(innerItem.id === currentBusinessIndex) {
                item = innerItem;
                setCurrentItem(item);
                }
            })
        });
    }, [currentBusinessIndex]);

    useEffect(() => {
        if (!infoLogo || !infoName) return

        infoLogo.current.classList.remove('--active')
        infoName.current.classList.remove('--active')

        setTimeout(() => {
        if (!infoLogo || !infoName) return
        infoLogo.current.classList.add('--active')
        infoName.current.classList.add('--active')
        }, 300)
    }, [currentBusinessIndex])

    return (
        <Fragment id="dicio_business" epicBarDirection="left">
            <Row className="scontainer">
                <Col md={6} className="bisn-right pad-all-40 ">
                    <ul>
                        {renderInnerContainer(business[0], 0, setCurrentBusinessIndex, currentBusinessIndex)}
                    </ul>
                </Col>
                <Col md={6} className="bisn-left center left" style={{paddingTop:"50px"}}>
                    <Row className="line">
                        <Col md={12} className="">
                            <h2 className=" title mrg-bt-10  line-height-title letter-spacing-3px mrg-right-60 fw-black fs-60">OUR ALIES</h2>
                            <p className="text-c-left fs-20 mrg-bt-20">
                                Our platform allows collaboration and interaction with companies from a wide variety of industries and different lines of business
                            </p>
                        </Col>
                        <Col md={12} ref={infoLogo} className=" radar-info">
                            <img src={currentItem.logo} style={{maxWidth: "100px", width: "100%"}} />
                        </Col>
                        <Col md={12} ref={infoName} className="pad-bottom-5 radar-info">
                            <p className="fw-bold c-blue fs-30">{currentItem.name}</p>
                        </Col>
                        {/* <div className="x:scol-12 x:pad-top-5">
                        <p>{business[currentBusinessIndex].description}</p>
                        </div> */}
                    </Row>
                </Col>
                {/* <Col md={6} className="s:scol-10  offset-2 pad-top-40 pad-top-10" style={{height:"409px", width:"409px"}}>
                    <ul>
                        {renderInnerContainer(business[0], 0, setCurrentBusinessIndex, currentBusinessIndex)}
                    </ul>
                </Col> */}
            </Row>
        </Fragment>
    )
}

export default Business;
